// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.distribution-dashboard {
  font-family: "Inter", -apple-system, BlinkMacSystemFont, sans-serif;
  background: linear-gradient(135deg, #f8fafc 0%, #f0f9ff 50%, #f5f3ff 100%);
  min-height: 100vh;
  padding: 24px;
}

/* Header Styles */
.distribution-header {
  background: white;
  border-radius: 20px;
  box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.1);
  border: 1px solid #e2e8f0;
  padding: 28px;
  margin-bottom: 28px;
  background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
}

.distribution-title {
  background: linear-gradient(135deg, #7c3aed 0%, #4f46e5 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  font-size: 38px;
  font-weight: 800;
  margin-bottom: 8px;
}

/* Control Bar */
.control-bar {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 24px;
  padding: 20px;
  background: white;
  border-radius: 16px;
  border: 1px solid #e2e8f0;
  flex-wrap: wrap;
}

.control-select {
  padding: 10px 16px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: white;
  font-size: 14px;
  color: #374151;
  min-width: 140px;
}

.control-badge {
  padding: 8px 16px;
  background: #10b981;
  color: white;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 600;
}

/* Summary Cards */
.summary-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 20px;
  margin-bottom: 28px;
}

.summary-card {
  background: white;
  border-radius: 16px;
  padding: 24px;
  border: 1px solid #e2e8f0;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
}

.summary-card::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(90deg, #7c3aed, #4f46e5);
}

.summary-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1);
}

.summary-value {
  font-size: 28px;
  font-weight: 800;
  margin-bottom: 8px;
}

.summary-label {
  font-size: 14px;
  color: #64748b;
  line-height: 1.4;
}

/* Table Styles */
.table-container {
  background: white;
  border-radius: 16px;
  border: 1px solid #e2e8f0;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05);
  margin-bottom: 28px;
  overflow: hidden;
}

.distribution-table {
  width: 100%;
  border-collapse: collapse;
}

.distribution-table th {
  background: linear-gradient(to right, #f8fafc, #ffffff);
  padding: 16px 20px;
  text-align: left;
  font-weight: 600;
  color: #374151;
  border-bottom: 1px solid #e2e8f0;
  font-size: 14px;
}

.distribution-table td {
  padding: 16px 20px;
  border-bottom: 1px solid #f1f5f9;
  font-size: 14px;
}

.distribution-table tr:hover {
  background: #f8fafc;
}

.distribution-table tr:last-child td {
  border-bottom: none;
}

/* Status Badges */
.status-badge {
  display: inline-flex;
  align-items: center;
  padding: 6px 12px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.status-paid {
  background: #dcfce7;
  color: #166534;
}

.status-processing {
  background: #fef3c7;
  color: #92400e;
}

.status-pending {
  background: #f3f4f6;
  color: #6b7280;
}

/* Action Buttons */
.action-button {
  display: inline-flex;
  align-items: center;
  padding: 8px 16px;
  border-radius: 8px;
  font-weight: 500;
  border: none;
  cursor: pointer;
  transition: all 0.3s ease;
  text-decoration: none;
  font-size: 13px;
  background: #f8fafc;
  color: #374151;
  border: 1px solid #e2e8f0;
}

.action-button:hover {
  background: #3b82f6;
  color: white;
  transform: translateY(-1px);
  box-shadow: 0 4px 6px -1px rgba(59, 130, 246, 0.3);
}

/* Chart Section */
.chart-section {
  display: grid;
  grid-template-columns: 2fr 1fr;
  gap: 24px;
  margin-bottom: 28px;
}

.chart-container {
  background: white;
  border-radius: 16px;
  padding: 24px;
  border: 1px solid #e2e8f0;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05);
}

.distribution-chart {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 16px;
}

.chart-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  background: #f8fafc;
  border-radius: 8px;
  border-left: 4px solid;
}

.chart-item.cebs {
  border-left-color: #7c3aed;
}

.chart-item.moei {
  border-left-color: #f59e0b;
}

.chart-item.ports {
  border-left-color: #10b981;
}

.chart-bar {
  flex: 1 1;
  height: 8px;
  background: #e2e8f0;
  border-radius: 4px;
  margin: 0 16px;
  overflow: hidden;
}

.chart-fill {
  height: 100%;
  border-radius: 4px;
}

.chart-fill.cebs {
  background: #7c3aed;
  width: 25%;
}

.chart-fill.moei {
  background: #f59e0b;
  width: 25%;
}

.chart-fill.ports {
  background: #10b981;
  width: 50%;
}

/* Audit Trail */
.audit-trail {
  background: white;
  border-radius: 16px;
  padding: 24px;
  border: 1px solid #e2e8f0;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05);
  margin-bottom: 28px;
}

.audit-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 16px;
}

.audit-table th {
  background: #f8fafc;
  padding: 12px 16px;
  text-align: left;
  font-weight: 600;
  color: #374151;
  border-bottom: 1px solid #e2e8f0;
  font-size: 13px;
}

.audit-table td {
  padding: 12px 16px;
  border-bottom: 1px solid #f1f5f9;
  font-size: 13px;
}

.audit-table tr:last-child td {
  border-bottom: none;
}

/* Action Bar */
.action-bar {
  display: flex;
  gap: 12px;
  justify-content: flex-end;
  padding: 20px;
  background: white;
  border-radius: 16px;
  border: 1px solid #e2e8f0;
}

.primary-button {
  display: inline-flex;
  align-items: center;
  padding: 12px 24px;
  border-radius: 12px;
  font-weight: 600;
  border: none;
  cursor: pointer;
  transition: all 0.3s ease;
  text-decoration: none;
  font-size: 14px;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
}

.primary-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1);
}

.btn-primary {
  background: linear-gradient(135deg, #7c3aed, #4f46e5);
  color: white;
}

.btn-primary:hover {
  background: linear-gradient(135deg, #6d28d9, #4338ca);
}

.btn-success {
  background: linear-gradient(135deg, #059669, #10b981);
  color: white;
}

.btn-success:hover {
  background: linear-gradient(135deg, #047857, #059669);
}

.btn-secondary {
  background: white;
  color: #374151;
  border: 1px solid #e2e8f0;
}

.btn-secondary:hover {
  background: #f8fafc;
  border-color: #cbd5e1;
}

/* Icon Styles */
.icon-small {
  width: 16px;
  height: 16px;
  margin-right: 8px;
}

/* Text Utilities */
.text-sm {
  font-size: 14px;
}
.text-lg {
  font-size: 18px;
}
.text-xl {
  font-size: 20px;
}
.text-2xl {
  font-size: 24px;
}
.text-3xl {
  font-size: 30px;
}

.font-semibold {
  font-weight: 600;
}
.font-bold {
  font-weight: 700;
}
.font-extrabold {
  font-weight: 800;
}

.text-slate-600 {
  color: #64748b;
}
.text-slate-700 {
  color: #374151;
}
.text-slate-800 {
  color: #1f2937;
}
.text-blue-600 {
  color: #2563eb;
}
.text-green-600 {
  color: #059669;
}
.text-purple-600 {
  color: #7c3aed;
}

/* Spacing Utilities */
.mb-2 {
  margin-bottom: 8px;
}
.mb-3 {
  margin-bottom: 12px;
}
.mb-4 {
  margin-bottom: 16px;
}
.mb-6 {
  margin-bottom: 24px;
}
.mt-2 {
  margin-top: 8px;
}
.mt-3 {
  margin-top: 12px;
}
.mt-4 {
  margin-top: 16px;
}
.mr-2 {
  margin-right: 8px;
}

/* Responsive Design */
@media (max-width: 1200px) {
  .summary-grid {
    grid-template-columns: repeat(2, 1fr);
  }

  .chart-section {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 768px) {
  .distribution-dashboard {
    padding: 16px;
  }

  .summary-grid {
    grid-template-columns: 1fr;
  }

  .distribution-header {
    padding: 20px;
  }

  .distribution-title {
    font-size: 28px;
  }

  .control-bar {
    flex-direction: column;
    align-items: flex-start;
  }

  .action-bar {
    flex-direction: column;
  }

  .table-container {
    overflow-x: auto;
  }

  .distribution-table {
    min-width: 800px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/dashboard/distribution-styles.css"],"names":[],"mappings":"AAAA;EACE,mEAAmE;EACnE,0EAA0E;EAC1E,iBAAiB;EACjB,aAAa;AACf;;AAEA,kBAAkB;AAClB;EACE,iBAAiB;EACjB,mBAAmB;EACnB,+CAA+C;EAC/C,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,6DAA6D;AAC/D;;AAEA;EACE,6DAA6D;EAC7D,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,8CAA8C;EAC9C,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,oDAAoD;AACtD;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;EACE,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,8CAA8C;EAC9C,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,uDAAuD;EACvD,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,kBAAkB;AAClB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,mBAAmB;AACnB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,qBAAqB;EACrB,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,2BAA2B;EAC3B,kDAAkD;AACpD;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,SAAO;EACP,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,UAAU;AACZ;;AAEA,gBAAgB;AAChB;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,8CAA8C;EAC9C,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,SAAS;EACT,yBAAyB;EACzB,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,qBAAqB;EACrB,eAAe;EACf,6CAA6C;AAC/C;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,qDAAqD;EACrD,YAAY;AACd;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,qDAAqD;EACrD,YAAY;AACd;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA,gBAAgB;AAChB;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA,mBAAmB;AACnB;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;;AAEA,sBAAsB;AACtB;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,iBAAiB;AACnB;;AAEA,sBAAsB;AACtB;EACE;IACE,qCAAqC;EACvC;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;AACF","sourcesContent":[".distribution-dashboard {\n  font-family: \"Inter\", -apple-system, BlinkMacSystemFont, sans-serif;\n  background: linear-gradient(135deg, #f8fafc 0%, #f0f9ff 50%, #f5f3ff 100%);\n  min-height: 100vh;\n  padding: 24px;\n}\n\n/* Header Styles */\n.distribution-header {\n  background: white;\n  border-radius: 20px;\n  box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.1);\n  border: 1px solid #e2e8f0;\n  padding: 28px;\n  margin-bottom: 28px;\n  background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);\n}\n\n.distribution-title {\n  background: linear-gradient(135deg, #7c3aed 0%, #4f46e5 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n  font-size: 38px;\n  font-weight: 800;\n  margin-bottom: 8px;\n}\n\n/* Control Bar */\n.control-bar {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  margin-bottom: 24px;\n  padding: 20px;\n  background: white;\n  border-radius: 16px;\n  border: 1px solid #e2e8f0;\n  flex-wrap: wrap;\n}\n\n.control-select {\n  padding: 10px 16px;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  background: white;\n  font-size: 14px;\n  color: #374151;\n  min-width: 140px;\n}\n\n.control-badge {\n  padding: 8px 16px;\n  background: #10b981;\n  color: white;\n  border-radius: 20px;\n  font-size: 12px;\n  font-weight: 600;\n}\n\n/* Summary Cards */\n.summary-grid {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 20px;\n  margin-bottom: 28px;\n}\n\n.summary-card {\n  background: white;\n  border-radius: 16px;\n  padding: 24px;\n  border: 1px solid #e2e8f0;\n  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05);\n  transition: all 0.3s ease;\n  position: relative;\n  overflow: hidden;\n}\n\n.summary-card::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 4px;\n  background: linear-gradient(90deg, #7c3aed, #4f46e5);\n}\n\n.summary-card:hover {\n  transform: translateY(-4px);\n  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1);\n}\n\n.summary-value {\n  font-size: 28px;\n  font-weight: 800;\n  margin-bottom: 8px;\n}\n\n.summary-label {\n  font-size: 14px;\n  color: #64748b;\n  line-height: 1.4;\n}\n\n/* Table Styles */\n.table-container {\n  background: white;\n  border-radius: 16px;\n  border: 1px solid #e2e8f0;\n  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05);\n  margin-bottom: 28px;\n  overflow: hidden;\n}\n\n.distribution-table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.distribution-table th {\n  background: linear-gradient(to right, #f8fafc, #ffffff);\n  padding: 16px 20px;\n  text-align: left;\n  font-weight: 600;\n  color: #374151;\n  border-bottom: 1px solid #e2e8f0;\n  font-size: 14px;\n}\n\n.distribution-table td {\n  padding: 16px 20px;\n  border-bottom: 1px solid #f1f5f9;\n  font-size: 14px;\n}\n\n.distribution-table tr:hover {\n  background: #f8fafc;\n}\n\n.distribution-table tr:last-child td {\n  border-bottom: none;\n}\n\n/* Status Badges */\n.status-badge {\n  display: inline-flex;\n  align-items: center;\n  padding: 6px 12px;\n  border-radius: 20px;\n  font-size: 12px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.status-paid {\n  background: #dcfce7;\n  color: #166534;\n}\n\n.status-processing {\n  background: #fef3c7;\n  color: #92400e;\n}\n\n.status-pending {\n  background: #f3f4f6;\n  color: #6b7280;\n}\n\n/* Action Buttons */\n.action-button {\n  display: inline-flex;\n  align-items: center;\n  padding: 8px 16px;\n  border-radius: 8px;\n  font-weight: 500;\n  border: none;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  text-decoration: none;\n  font-size: 13px;\n  background: #f8fafc;\n  color: #374151;\n  border: 1px solid #e2e8f0;\n}\n\n.action-button:hover {\n  background: #3b82f6;\n  color: white;\n  transform: translateY(-1px);\n  box-shadow: 0 4px 6px -1px rgba(59, 130, 246, 0.3);\n}\n\n/* Chart Section */\n.chart-section {\n  display: grid;\n  grid-template-columns: 2fr 1fr;\n  gap: 24px;\n  margin-bottom: 28px;\n}\n\n.chart-container {\n  background: white;\n  border-radius: 16px;\n  padding: 24px;\n  border: 1px solid #e2e8f0;\n  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05);\n}\n\n.distribution-chart {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  margin-top: 16px;\n}\n\n.chart-item {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 12px 16px;\n  background: #f8fafc;\n  border-radius: 8px;\n  border-left: 4px solid;\n}\n\n.chart-item.cebs {\n  border-left-color: #7c3aed;\n}\n\n.chart-item.moei {\n  border-left-color: #f59e0b;\n}\n\n.chart-item.ports {\n  border-left-color: #10b981;\n}\n\n.chart-bar {\n  flex: 1;\n  height: 8px;\n  background: #e2e8f0;\n  border-radius: 4px;\n  margin: 0 16px;\n  overflow: hidden;\n}\n\n.chart-fill {\n  height: 100%;\n  border-radius: 4px;\n}\n\n.chart-fill.cebs {\n  background: #7c3aed;\n  width: 25%;\n}\n\n.chart-fill.moei {\n  background: #f59e0b;\n  width: 25%;\n}\n\n.chart-fill.ports {\n  background: #10b981;\n  width: 50%;\n}\n\n/* Audit Trail */\n.audit-trail {\n  background: white;\n  border-radius: 16px;\n  padding: 24px;\n  border: 1px solid #e2e8f0;\n  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05);\n  margin-bottom: 28px;\n}\n\n.audit-table {\n  width: 100%;\n  border-collapse: collapse;\n  margin-top: 16px;\n}\n\n.audit-table th {\n  background: #f8fafc;\n  padding: 12px 16px;\n  text-align: left;\n  font-weight: 600;\n  color: #374151;\n  border-bottom: 1px solid #e2e8f0;\n  font-size: 13px;\n}\n\n.audit-table td {\n  padding: 12px 16px;\n  border-bottom: 1px solid #f1f5f9;\n  font-size: 13px;\n}\n\n.audit-table tr:last-child td {\n  border-bottom: none;\n}\n\n/* Action Bar */\n.action-bar {\n  display: flex;\n  gap: 12px;\n  justify-content: flex-end;\n  padding: 20px;\n  background: white;\n  border-radius: 16px;\n  border: 1px solid #e2e8f0;\n}\n\n.primary-button {\n  display: inline-flex;\n  align-items: center;\n  padding: 12px 24px;\n  border-radius: 12px;\n  font-weight: 600;\n  border: none;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  text-decoration: none;\n  font-size: 14px;\n  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);\n}\n\n.primary-button:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1);\n}\n\n.btn-primary {\n  background: linear-gradient(135deg, #7c3aed, #4f46e5);\n  color: white;\n}\n\n.btn-primary:hover {\n  background: linear-gradient(135deg, #6d28d9, #4338ca);\n}\n\n.btn-success {\n  background: linear-gradient(135deg, #059669, #10b981);\n  color: white;\n}\n\n.btn-success:hover {\n  background: linear-gradient(135deg, #047857, #059669);\n}\n\n.btn-secondary {\n  background: white;\n  color: #374151;\n  border: 1px solid #e2e8f0;\n}\n\n.btn-secondary:hover {\n  background: #f8fafc;\n  border-color: #cbd5e1;\n}\n\n/* Icon Styles */\n.icon-small {\n  width: 16px;\n  height: 16px;\n  margin-right: 8px;\n}\n\n/* Text Utilities */\n.text-sm {\n  font-size: 14px;\n}\n.text-lg {\n  font-size: 18px;\n}\n.text-xl {\n  font-size: 20px;\n}\n.text-2xl {\n  font-size: 24px;\n}\n.text-3xl {\n  font-size: 30px;\n}\n\n.font-semibold {\n  font-weight: 600;\n}\n.font-bold {\n  font-weight: 700;\n}\n.font-extrabold {\n  font-weight: 800;\n}\n\n.text-slate-600 {\n  color: #64748b;\n}\n.text-slate-700 {\n  color: #374151;\n}\n.text-slate-800 {\n  color: #1f2937;\n}\n.text-blue-600 {\n  color: #2563eb;\n}\n.text-green-600 {\n  color: #059669;\n}\n.text-purple-600 {\n  color: #7c3aed;\n}\n\n/* Spacing Utilities */\n.mb-2 {\n  margin-bottom: 8px;\n}\n.mb-3 {\n  margin-bottom: 12px;\n}\n.mb-4 {\n  margin-bottom: 16px;\n}\n.mb-6 {\n  margin-bottom: 24px;\n}\n.mt-2 {\n  margin-top: 8px;\n}\n.mt-3 {\n  margin-top: 12px;\n}\n.mt-4 {\n  margin-top: 16px;\n}\n.mr-2 {\n  margin-right: 8px;\n}\n\n/* Responsive Design */\n@media (max-width: 1200px) {\n  .summary-grid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n\n  .chart-section {\n    grid-template-columns: 1fr;\n  }\n}\n\n@media (max-width: 768px) {\n  .distribution-dashboard {\n    padding: 16px;\n  }\n\n  .summary-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .distribution-header {\n    padding: 20px;\n  }\n\n  .distribution-title {\n    font-size: 28px;\n  }\n\n  .control-bar {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n\n  .action-bar {\n    flex-direction: column;\n  }\n\n  .table-container {\n    overflow-x: auto;\n  }\n\n  .distribution-table {\n    min-width: 800px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
